// Collection descriptions and metadata
export const collectionDescriptions = {
  // Categories
  Cinematic: {
    description: "Epic orchestral pieces and dramatic scores perfect for film, video, and storytelling. From sweeping symphonies to intimate character themes.",
    featured: true
  },
  Ambient: {
    description: "Atmospheric soundscapes and textures that create immersive environments. Perfect for meditation, focus, and background ambiance.",
  },
  Corporate: {
    description: "Professional and polished tracks ideal for business presentations, commercials, and corporate media.",
  },
  Uplifting: {
    description: "Positive and motivational music that inspires and energizes. Great for vlogs, promotional content, and feel-good moments.",
  },
  Calm: {
    description: "Gentle and soothing melodies designed to create a peaceful atmosphere. Ideal for relaxation and wellness content.",
  },
  Piano: {
    description: "Beautiful piano compositions ranging from emotional solo pieces to modern piano-driven tracks.",
  },
  Peaceful: {
    description: "Tranquil and serene music perfect for creating a relaxing environment or accompanying mindfulness content.",
  },
  Energetic: {
    description: "High-energy tracks that add excitement and dynamism to any project. Perfect for sports, action scenes, and upbeat content.",
  },
  Epic: {
    description: "Powerful and grandiose compositions featuring full orchestras and dramatic elements. Ideal for trailers and intense moments.",
  },
  Guitar: {
    description: "Expressive guitar tracks spanning acoustic fingerpicking to electric riffs. Perfect for intimate moments or adding character to your projects.",
  },
  Sad: {
    description: "Emotional and melancholic pieces that evoke feelings of nostalgia and contemplation. Ideal for dramatic scenes and touching moments.",
  },
  Lofi: {
    description: "Relaxed beats with warm textures and nostalgic elements. Perfect for study sessions, focus time, or chilled content.",
  },
  Romantic: {
    description: "Tender and affectionate compositions that capture the essence of love and connection. Great for wedding videos and heartfelt moments.",
  },
  Happy: {
    description: "Joyful and cheerful tracks that spread positivity and good vibes. Perfect for celebratory content and upbeat moments.",
  },
  Pop: {
    description: "Catchy and contemporary tracks with modern production. Ideal for commercials, social media content, and mainstream appeal.",
  },
  Vaporwave: {
    description: "Nostalgic electronic music with retro aesthetics and dreamy atmospheres. Perfect for artistic projects with a unique vibe.",
  },
  Electronic: {
    description: "Digital sounds and synthesized elements creating modern and innovative soundscapes. Great for technology-focused content.",
  },
  Angry: {
    description: "Intense and powerful tracks with aggressive elements. Suitable for confrontational scenes and high-tension moments.",
  },
  "Hip-hop": {
    description: "Rhythmic beats with urban flavor and groove. Perfect for fashion, lifestyle content, and contemporary projects.",
  },
  Beats: {
    description: "Percussion-driven tracks with strong rhythmic elements. Ideal for backing tracks, intros, and content requiring a strong pulse.",
  },
  Mysterious: {
    description: "Intriguing and enigmatic compositions that create suspense and curiosity. Perfect for mystery, thriller, and puzzle-based content.",
  },
  Accordion: {
    description: "Distinctive accordion-focused pieces with character and charm. Great for cultural content, European themes, and unique flavor.",
  },
  Celtic: {
    description: "Traditional Irish and Celtic-inspired music with authentic instruments. Ideal for cultural content, fantasy projects, and historical themes.",
  },
  Classical: {
    description: "Timeless compositions in traditional classical style with refined elegance. Perfect for sophisticated content and artistic projects.",
  },
  Holiday: {
    description: "Festive and seasonal music for celebrations and special occasions. Ideal for holiday content, greeting videos, and seasonal promotions.",
  },
  Trumpet: {
    description: "Bold and brassy trumpet-focused pieces with character and presence. Great for announcements, transitions, and attention-grabbing moments.",
  },
  Meditation: {
    description: "Deep and mindful compositions designed for relaxation and inner peace. Perfect for wellness content, yoga videos, and mindfulness practices.",
  },
  Jazz: {
    description: "Sophisticated jazz tracks with improvisation and swing. Ideal for elegant content, urban scenes, and sophisticated atmospheres.",
  },
  "Video game": {
    description: "Dynamic and interactive-ready music inspired by gaming culture. Perfect for gaming content, tutorials, and tech-focused projects.",
  },
  Choir: {
    description: "Powerful vocal ensemble pieces with emotional depth and human connection. Great for spiritual content, epic moments, and emotional impact.",
  },
  Vocals: {
    description: "Tracks featuring human voices as the primary element. Ideal for projects requiring a human touch and emotional connection.",
  },
  Metal: {
    description: "Heavy and powerful tracks with distorted guitars and intense energy. Perfect for action sequences, sports, and high-octane content.",
  },
  Acoustic: {
    description: "Natural and organic instrumental tracks with an unplugged feel. Perfect for authentic storytelling, lifestyle content, and intimate moments.",
  },
  Experimental: {
    description: "Innovative and boundary-pushing compositions that blend genres and techniques. Ideal for artistic projects, abstract visuals, and avant-garde content.",
    featured: true
  },
  Funky: {
    description: "Groove-driven tracks with infectious basslines and rhythmic elements. Great for retro themes, dance content, and upbeat promotional videos.",
  },
  Indie: {
    description: "Alternative and authentic tracks with a raw, independent feel. Perfect for creative projects, indie films, and content with an artistic edge.",
  },
  
  // Prompters
  'Human Underscore': {
    description: "A curated collection of AI tracks from the [premier music studio](https://www.humanunderscore.com). Each piece is carefully crafted to match human-level musicality and emotion.",
    featured: true
  },
  'Chris Mcmurtry': {
    description: "Trifocii, or something like that.",
    displayName: "Chris McMurtry"
  }
}; 